import { AfterViewInit, Component, Input, Output, ElementRef, EventEmitter, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

declare const $: any;

@Component({
  selector: 'glyph',
  template: `<i *ngIf="glyph" class="{{glyph}}"></i>`,
  encapsulation: ViewEncapsulation.None,
})

export class GlyphComponent {
  @Input() public name: string = '';
  public caption: string = '';
  @Input() public value: string = '';
  @Input() public enabled: Boolean = false;
  @Input() public glyph: string;
  @Input() public options: any;
  @Input() public item: any;
  public init: boolean = false;

  constructor() {
  }

  initialize() {
    if (!this.options) {
      this.options = { assign: [], fieldName: '' };
    }
  }

  ngOnInit() {
    this.initialize();
    if (!this.init) {
      this.init = true;
      for (let i = 0; i <= this.options.assign.length - 1; i++) {
        if (this.value != null) {
          if (this.options.assign[i].value == this.value.trim()) {
            this.glyph = this.options.assign[i].glyph;
            break;
          }
        }
      }
      if ((this.options.fieldName) && (this.options.fieldName in this.item)) {
        this.caption = this.value;
      } else {
        this.caption = '';
      }
    }
  }
}
